import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Pill, PillTone } from "@tenant/ui";
import clsx from "clsx";
import styles from "./BonusEarnPill.module.scss";
import { useBonusEarnBanner } from "./useBonusEarnBanner";

export type BonusEarnPillVariant = "badge" | "earn" | "earning" | "earned";

export interface BonusEarnPillProps {
  /**
   * Copy variant: "badge" ("3X points"), "earn" (payment card rows),
   * "earning" (checkout breakdown) or "earned" (confirmation breakdown).
   */
  variant?: BonusEarnPillVariant;
  className?: string;
}

export const BonusEarnPill = ({
  variant = "badge",
  className,
}: BonusEarnPillProps) => {
  const [, cn] = useModuleBEM(styles, "BonusEarnPill");
  const { t } = useI18nContext();
  const {
    context: { resource },
  } = useBonusEarnBanner();

  if (!resource) return null;

  const earnRate = resource.bonusPointsEarnRate;
  const label = {
    badge: () => t("bonusEarnBanner.dialog.badge", { earnRate }),
    earn: () => t("bonusEarnBanner.pill.earn", { earnRate }),
    earning: () => t("bonusEarnBanner.pill.earning", { earnRate }),
    earned: () => t("bonusEarnBanner.pill.earned", { earnRate }),
  }[variant]();

  return (
    <Pill
      className={clsx(cn("badge"), className)}
      size="custom"
      tone={PillTone.custom}
    >
      {label}
    </Pill>
  );
};
